import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { IRespAcompanante } from '../interfaces/existe-acompanante.interface';
import { environment } from '@environments/environment';
import { IndexdbService } from '../../core/database/indexdb.service';

@Injectable({
  providedIn: 'root'
})
export class ExisteAcompananteService {
  private apiUrl = environment.baseURL + 'acompaniante/existe-acompaniante';

  private readonly indexDbService: IndexdbService = inject(IndexdbService);
  private readonly httpClient: HttpClient = inject(HttpClient);

  getExisteAcompanante(numeroDocumento: string): Observable<IRespAcompanante> {
    const params = new
      HttpParams()
      .set('client-id', '4b9b9ab5b734408d915ec31751bbf114')
      .set('numeroDocumento', numeroDocumento);
    return this.httpClient.get<IRespAcompanante>(this.apiUrl, { params });
  }

  getParentezcoAcompanante() {
    return this.indexDbService.getDatosPersonales().pipe(
      map(result => result?.parentescos ?? [])
    );
  }
}
